const config = {
  headers: {
    Authorization: ''
  },
  timeout: 3000 * 10 // Wait for 10 seconds
};

export default config;
